export default __webpack_public_path__ + "static/media/image-2.7c62d843.png";